// extracted by mini-css-extract-plugin
export default {"industryHomeWrapper":"IndustryHome_industryHomeWrapper__iKo0L"};